import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-white shadow-sm fixed w-full top-0 z-50">
      <div className="max-w-[1250px] mx-auto px-6">
        <div className="flex justify-between items-center py-5">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/">
              <img 
                src="/throttle.png" 
                alt="Logo" 
                className="h-14 w-auto"
              />
            </Link>
          </div>

          {/* Desktop Navigation - All Items in Two Rows */}
          <div className="hidden lg:block">
            {/* First Row */}
            <div className="flex items-center justify-end space-x-7 mb-2">
              <Link 
                to="/" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                HOME
              </Link>
              <Link 
                to="/dunes-dirt-report" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/dunes-dirt-report') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                DIRT REPORT
              </Link>
              <Link 
                to="/memberships" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/memberships') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                2026 MEMBERSHIPS
              </Link>
              <Link 
                to="/park-rules" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/park-rules') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                PARK INFO/RULES
              </Link>
              <Link 
                to="/rider-training" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/rider-training') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                TRAINING
              </Link>
              <Link 
                to="/summer-camps" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/summer-camps') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                SUMMER CAMPS
              </Link>
              <Link 
                to="/bike-rentals" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/bike-rentals') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                RENTALS
              </Link>
              <Link 
                to="/store" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/store') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                STORE
              </Link>
              <Link 
                to="/cabins" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/cabins') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                CABINS
              </Link>
            </div>
            
            {/* Second Row */}
            <div className="flex items-center justify-end space-x-7">
              <Link 
                to="/special-events" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/special-events') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                SPECIAL EVENTS
              </Link>
              <Link 
                to="/gdr" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/gdr') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                GDR TEAM
              </Link>
              <Link 
                to="/contact-us" 
                className={`text-[10px] font-bold text-gray-900 hover:text-gray-600 tracking-widest transition-colors ${isActive('/contact-us') ? 'border-b-2 border-black pb-0.5' : ''}`}
              >
                CONTACT US - FAQ
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-800 hover:bg-gray-100"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link
              to="/"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              HOME
            </Link>
            <Link
              to="/dunes-dirt-report"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              DIRT REPORT
            </Link>
            <Link
              to="/memberships"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              2026 MEMBERSHIPS
            </Link>
            <Link
              to="/park-rules"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              PARK INFO/RULES
            </Link>
            <Link
              to="/rider-training"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              TRAINING
            </Link>
            <Link
              to="/summer-camps"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              SUMMER CAMPS
            </Link>
            <Link
              to="/bike-rentals"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              RENTALS
            </Link>
            <Link
              to="/store"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              STORE
            </Link>
            <Link
              to="/cabins"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              CABINS
            </Link>
            <Link
              to="/special-events"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              SPECIAL EVENTS
            </Link>
            <Link
              to="/gdr"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              GDR TEAM
            </Link>
            <Link
              to="/contact-us"
              className="block px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 rounded-md"
              onClick={() => setMobileMenuOpen(false)}
            >
              CONTACT US - FAQ
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
